<template>
  <div class="Banner content">
      <div class="tournamentName fancyHeading">{{text}}</div>
  </div>
</template>

<script>
export default {
  name: 'Banner',
  props: ["text"],
}
</script>

<style scoped>


.Banner{
    background-color: #33333333;
    height: 250px;
    text-align: center;
    width: -webkit-fill-available;
    background: url(../assets/dvabanner.png);
    background-size: cover;
    background-position: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Banner.vue